export const getNameInitials = (name: string = '') => {
    return name
        .split(' ')
        .slice(0, 2)
        .map((el) => el.charAt(0).toUpperCase())
        .join('')
}
